module.exports = __webpack_public_path__ + "static/teleco_15-ca38d9d565be9c496e4894c666a26ef3.jpg";